<template>
  <div class="bg-secondary-1 rounded mb-4 py-4 px-3">
    <div class="row justify-content-between mx-lg-5 px-1">
      <div class="col-12 col-lg mb-3 mb-lg-0">
        <div class="d-flex">
          <i class="fas fa-file-user text-yellow-dark mr-3 font-50"></i>
          <div>
            <label class="font-weight-semibold font-14 m-0 text-gray">
              Total de Requisiciones:
            </label>
            <p class="font-22 text-yellow-dark m-0 font-weight-bold">
              {{ summary.total | currency }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg mb-3 mb-lg-0">
        <div class="d-flex">
          <i class="fas fa-file-user text-success mr-3 font-50"></i>
          <div>
            <label class="font-weight-semibold font-14 m-0 text-gray">
              Equipos Requisados:
            </label>
            <p class="font-22 text-success m-0 font-weight-bold">
              {{ summary.requisitioned | currency }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg mb-3 mb-lg-0">
        <div class="d-flex">
          <i class="fas fa-file-user mr-3 font-50 text-orange"></i>
          <div>
            <label class="font-weight-semibold font-14 m-0 text-gray">
              Pendientes a Requisar:
            </label>
            <p class="font-22 m-0 text-orange font-weight-bold">
              {{ summary.pending | currency }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg mb-3 mb-lg-0">
        <div class="d-flex">
          <i class="fas fa-file-user mr-3 font-50 text-gray-dark"></i>
          <div>
            <label class="font-weight-semibold font-14 m-0 text-gray">
              Equipos a Requisar:
            </label>
            <p class="font-22 text-gray-dark m-0 font-weight-bold">
              {{ summary.toRequisition | currency }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg mb-3 mb-lg-0">
        <div class="d-flex">
          <i class="fas fa-usd-circle mr-3 font-50 text-success"></i>
          <div>
            <label class="font-weight-semibold m-0 font-14 text-gray">
              Monto Total:
            </label>
            <p class="font-22 m-0 text-success font-weight-bold">
              {{ summary.totalAmount | price }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RequisitionSummary',
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.font-50 {
  font-size: 50px;
}

.text-yellow-dark {
  color: #f3af54;
}

.font-weight-semibold {
  font-weight: 400;
}
</style>
